module.exports = __webpack_public_path__ + "static/media/Q2-9.adaf2d23.JPG";